const TaxFeeType = {
  Percent: 'Percent',
  Flat: 'Flat'
};

export default TaxFeeType;
